import React from 'react'
import LeftBarSheets from '../ui/LeftBarSheets'
import DropDownMenu from '../ui/DropDownMenu'
import AssessmentIcon from '@mui/icons-material/Assessment';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import LoadingSpinner from '../../components/ui/LoadingSpinner'
import { dateParser } from '../utilities/helperFunctions'
import left from '../../images/js/left'
import right from '../../images/js/right'

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`
    };
}

function TabPanel(props) {
    const {
        children, value, index, ...other
    } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Typography>{children}</Typography>}
        </div>
    );
}

class Sheets extends React.Component {

    state = {
        quickPicks: false,
        value: 0
    }

    emptyCheck = (str) => {
        switch (str) {
            case 'quickPicks':
                return (this.props.presentationView.quickPicks && (this.props.presentationView.quickPicks.length > 0)) ? true : false
            default:
                return true
        }
    }

    showMenu = (str) => {
        let keys = Object.keys(this.state)
        let obj = {}
        keys.map(x => { return obj[x] = false })
        obj[str] = true
        this.setState({ ...obj })
    }

    hideMenu = (str) => {
        this.setState({ [str]: false })
    }

    handleMouseEnter = (event) => {
        event.preventDefault()
        this.showMenu(event.target.dataset.name)
    }

    handleMouseExit = (event) => {
        event.preventDefault()
        this.hideMenu(event.target.dataset.name)
    }

    handleDownloadPresentation = (event) => {
        event.preventDefault()
        this.props.downloadPresentation(this.props.presentationView.presentationID, this.props.presentationView.presentation.name + ".xlsx")
    }

    handleQPClick = (event) => {
        event.preventDefault()
        this.props.showQuickPickEditor(this.props.presentationView.presentationID);
    }

    handleViewPresentation = (event) => {
        event.preventDefault()
        this.props.showPopup("sheetViewPopup")
    }

    handleChange = (event, newValue) => {       
        this.setState({
            value: newValue
        })
        if (newValue === 1) {
            this.handleQPClick(event)
        }
    };

    isPresentationStandAlone = () => {
        return this.props.presentationView && this.props.presentationView.presentation && (this.props.presentationView.presentation.parentPresentation === undefined || this.props.presentationView.presentation.parentPresentation === null);
    }

    showButtons = () => {
        if (this.props.isPresentationBigLoaded && this.isPresentationStandAlone()) {
            return (
                <Tabs value={this.state.value} onChange={() => this.handleChange}>
                    <Tab label="Preview" {...a11yProps(0)} />
                    <Tab
                        onClick={this.handleQPClick}
                        label="Quick Picks"
                        {...a11yProps(1)}
                    />
                </Tabs>
            )
        } else {
            return (
                <Tabs value={this.state.value} onChange={this.handleChange}>
                    <Tab label="Preview" {...a11yProps(0)} />
                </Tabs>
            )
        }
    }

    showMain = () => {
        if (this.props.isPresentationBigLoaded && this.props.sheet !== null) {
            return (<TabPanel value={this.state.value} index={0}>
                <div className="showImgOut">
                <div className="tableHeaderBox">
                        {(this.props.sheet !== undefined && this.props.sheet !== null) ? <button onClick={this.moveSheet} data-id={this.props.sheet.sheetID} data-name="back" style={{ 'left': "216px" }}>{left("black", "20px")}</button> : null}
                        <button style={{ 'left': "258px" }} data-category="createdBy">{this.renderSheetSubtitle()}</button>
                        {(this.props.sheet !== undefined && this.props.sheet !== null) ? <button onClick={this.moveSheet} data-id={this.props.sheet.sheetID} data-name="forward" style={{ 'left': "310px" }}>{right("black", "20px")}</button> : null }
                    </div>

                    <img className="sheetImg" src={`data:image/jpeg;base64,${this.props.sheet.sheetImage.imageBytes}`} alt={`sheet_${this.props.sheet.sheetIndex}`} />
                </div>
            </TabPanel>)
        } else {
            return (<div className='sheetImageBox'>
                <div className='sheetLoadingSpinnerHolder'>
                    <LoadingSpinner loadingMessage="Loading Sheets..." />
                </div>
                <h3>Name: </h3>
                <p>{this.props.presentationView.presentation && this.props.presentationView.presentation.name}</p>
                <h3>Created By: </h3>
                <p>{this.props.presentationView.createdBy}</p>
                <h3>Last Modified: </h3>
                <p>{this.props.presentationView.presentation && dateParser(this.props.presentationView.presentation.modifiedDate)}</p>
                <h3>QuickPicks </h3>
                {(this.props.presentationView.quickPicks !== undefined) ? this.props.presentationView.quickPicks.map(x => <p key={x.id} >{x.tagName} - {x.quickPicksTag.targetSelection}</p>) : null}
            </div>)
        }
    }

    showDropdown = () => {
        const ind = Object.values(this.state).indexOf(true)
        if (ind !== -1) {
            let name = Object.keys(this.state)[ind]
            return <DropDownMenu name={name}
                presentationView={this.props.presentationView}
                hideMenu={this.hideMenu}
                showMenu={this.showMenu}
                showQuickPickEditor={this.props.showQuickPickEditor}
                showGlobalEditor={this.props.showGlobalEditor}
            />
        } else {
            return null
        }
    }

    giveActive = () => {
        let keys = Object.keys(this.state)
        let vals = Object.values(this.state)
        if (vals.includes(true)) {
            return keys[vals.indexOf(true)]
        } else {
            return null
        }
    }

    lookUp = {
        "info": { left: "10px", width: "180px" },
        "dataSources": { left: "190px", width: "140px" },
        "queries": { left: "330px", width: "100px" },
        "quickPicks": { left: "430px", width: "130px" },
        "globals": { left: "560px", width: "120px" },
    }

    moveSheet = (event) => {
        event.preventDefault()
        if (event.target.dataset.name === "forward") {
            if (this.props.sheetEnd !== this.props.sheet.sheetIndex) { this.props.viewSheet(parseFloat(this.props.sheet.sheetIndex) + 1) }
        } else {
            if (this.props.sheet.sheetIndex !== this.props.sheetBegin) { this.props.viewSheet(parseFloat(this.props.sheet.sheetIndex) - 1) }
        }
    }

    renderActive = (str) => {
        return (this.state[str] === true && this.emptyCheck(str)) ? `tableMenuButton open` : `tableMenuButton`
    }

    renderName = () => {
        return (this.props.presentationView.presentation !== undefined) ? ` ${this.props.presentationView.presentation.name}` : " Presentation"
    }

    renderSheetCount = () => {
        return (this.props.presentationView.sheets !== undefined) ? `${this.props.presentationView.sheets.length} Sheets` : "Sheets"
    }

    renderSheetSubtitle = () => {
        return (this.props.presentationView.sheets !== undefined && this.props.sheet !== null) ? `${this.props.sheet.sheetIndex} / ${this.props.presentationView.sheets.length}` : null
    }

    render() {
        return (
            <div className="mainWrapper">
                <div className="bodyPart">
                    <div className="contentWrapper">
                        <h2 className="pageHead">
                            <AssessmentIcon />
                            <span className="mainTitleBox">{this.renderName()}</span>
                            <div className="rightButton">
                                <button className="btn" onClick={this.handleViewPresentation}>
                                    Sheet View
                            </button>
                                <button className="btn" onClick={this.handleDownloadPresentation}>Download</button>
                            </div>
                        </h2>
                        <div className="tabOutMain presentAtionOut">
                            <AppBar position="static">
                                <div className="TabsData">
                                    {this.showButtons()}
                                </div>
                            </AppBar>
                            <div className="tabsContainerBox">
                                {this.showDropdown()}
                                <div className="presentLeft">
                                    <LeftBarSheets
                                        presentationView={this.props.presentationView}
                                        sheets={this.props.presentationView.sheets}
                                        viewSheet={this.props.viewSheet}
                                        sheet={this.props.sheet}
                                        isPresentationBigLoaded={this.props.isPresentationBigLoaded}
                                    />
                                </div>
                                <div className="presentRight">
                                    {this.showMain()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default Sheets